var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGridinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8h4c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2H2C.9 0 0 .9 0 2v4c0 1.1.9 2 2 2zM2 18h4c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2H2c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2zM10 2v4c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2zM12 18h4c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2z",
    fill: "inherit"
  })));
}

export default SvgGridinline;